import { Box, Table, TableBody, TableCell, TableRow, TableHeader } from 'grommet'

var partedDisplacements = []

function DisplacementResults(props) {
    for(let i=0; i < props.nNodes; i++){
        partedDisplacements[i] = new Array(2)
        for(let j = 0; j<3; j++){
            partedDisplacements[i][j] = props.results[3*i+j]
        }
    }
  return (
      <Box justify='center' align='center' pad='xsmall'>
        <h2>Deslocamentos</h2>
        <Table>
            <TableHeader>
                <TableRow>
                  <TableCell scope="col" border="bottom">
                    Nó
                  </TableCell>
                  <TableCell scope="col" border="bottom">
                    u
                  </TableCell>
                  <TableCell scope="col" border="bottom">
                    v
                  </TableCell>
                  <TableCell scope="col" border="bottom">
                    Theta
                  </TableCell>
                </TableRow>
              </TableHeader>
            <TableBody>
                {partedDisplacements.map((item, i) => {
                  return(
                    <TableRow>
                        <TableCell>
                        {i+1}
                      </TableCell>

                      <TableCell>
                        {item[0] < 0.0001 && item[0] > 0 ? 0 + " m" : item[0].toFixed(5) + " m"}
                      </TableCell>

                      <TableCell>
                        {item[1] < 0.0001 && item[1] > 0 ? 0 + " m" : item[1].toFixed(5) + " m"}
                      </TableCell>

                      <TableCell>
                        {item[2] < 0.0001 && item[2] > 0 ? 0 + " rad" : item[2].toFixed(5) + " rad"}
                      </TableCell>
                    </TableRow>
                  )})}
            </TableBody>
        </Table>
      </Box>
  )
}

export default DisplacementResults